<template>
  <app-launcher-container
    :user-id="userId"
    :multi-user-id="multiUserId"
    :is-ready="isReady"
    @sign-out="$emit('sign-out')"
  />
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance } from 'vue-demi';
import { setActivePinia } from 'pinia';

import AppLauncherContainer from './containers/AppLauncherContainer.vue';
import { useI18n, useHttpSDK, useAuth, useAppThemeTracking } from '@/composables';

/** Component that initializes Pinia, SDKs and i18n */
export default defineComponent({
  name: 'AppLauncherInitializer',
  components: { AppLauncherContainer },
  props: {
    isReady: Boolean,
  },
  emits: ['sign-out'],
  setup() {
    const vm = getCurrentInstance()!;
    setActivePinia(vm.proxy.$pinia);

    const { initializeHttpSDKs } = useHttpSDK();
    const { initializeI18n } = useI18n();
    const { initializeThemeTracking } = useAppThemeTracking();
    const { userId, multiUserId } = useAuth();

    initializeI18n();
    initializeThemeTracking();

    return { userId, multiUserId, initializeI18n, initializeHttpSDKs };
  },
  watch: {
    isReady(isReady: boolean) {
      if (isReady) {
        this.initializeHttpSDKs();
      }
    },
    /* Activates when user switches account in another tab for example */
    userId(current, previous) {
      if (current !== previous && current && previous) {
        this.initializeHttpSDKs();
      }
    },
  },
});
</script>
